/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowSocialMediaMarketingWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowSocialMediaMarketingWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Boost Our Brands!",
    "Social Media Workshop Awaits!",
    "Marketing Magic!",
  ],
  title: "Social Media Marketing Workshop",
  description: "Organize an informative social media marketing workshop.",
  longDescription:
    "Gather your friends for a social media marketing workshop! Choose a date, decide on topics to cover, and plan activities for the session!",
  emoji: "📱",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Social Media Marketing Workshop",
          emoji: "📱",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the social media marketing workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on topics to cover?",
            description:
              "What topics do we want to explore during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What topics should we consider?",
                emoji: "💼",
                completeAction: {
                  question: "Decide on tools needed?",
                  description: "What tools should we gather for marketing?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What tools should we bring?",
                      emoji: "🧰",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Market Together!",
    outroDescription:
      "Your social media marketing workshop plans are set! Enjoy the learning!",
  },
};
